import './CreditsPage.scss'
import {t} from "i18next";

const CreditsPage = (props) => {
  const {
    onChangeView,
  } = props


  return <div className="CreditsPage">
    <div className="CreditsPage-header"><h2>{t('credits-title')} </h2></div>
      <div className="sasha">
        <div className="info">
          <h2>dO_oy</h2>
          <div>{t('credits-gd')}</div>
          <div>{t('credits-prog')}</div>
          <div>{t('credits-sf')}</div>
          <div>{t('credits-test')}</div>
          <div>{t('credits-crr')}</div>
          <div>{t('credits-leader')}</div>
          <div className="contacts">
            <div><a href="https://t.me/neuro_io" target="_blank" rel="noreferrer" className="link" >Telegram</a></div>
            <div><a href="https://do-oy.itch.io" target="_blank" rel="noreferrer" className="link" >Itch.io</a></div>
            <div><a href="https://www.twitch.tv/do_oy" target="_blank" rel="noreferrer" className="link" >Twitch</a></div>
          </div>
        </div>
        <div className="photo" />
      </div>
      <div className="katya">
        <div className="info">
          <h2>katy.k.art</h2>
          <div>{t('credits-Artist')}</div>
          <div>{t('credits-Brainstorming')}</div>
          <div className="contacts">
            <div className="row-links">
              <a href="https://t.me/katykopylova" target="_blank" rel="noreferrer" className="link" >Telegram</a>
              <a href="https://www.fiverr.com/katy_k_" target="_blank" rel="noreferrer" className="link" >Fiverr</a>
            </div>
            <div className="row-links">
              <a href="https://www.instagram.com/katy.k.art" target="_blank" rel="noreferrer" className="link" >Instagram</a>
            </div>
          </div>
        </div>
        <div className="photo" />
      </div>
      <div className="non">
        <div className="info">
          <h2>NON-LIMITED</h2>
          <div>{t('credits-sound')}</div>
          <div className="contacts">
            <div><a href="https://t.me/JOVIL6" target="_blank" rel="noreferrer" className="link" >Telegram</a></div>
            <div><a href="https://band.link/NONN" target="_blank" rel="noreferrer" className="link" >Bandlink</a></div>
          </div>
        </div>
        <div className="photo" />
      </div>

      <button className="back-button" onClick={()=>onChangeView("MenuPage")}> {t('back')} </button>
  </div>
}

export default CreditsPage